import { render, staticRenderFns } from "./rightSideber.vue?vue&type=template&id=12c3099c"
import script from "./rightSideber.vue?vue&type=script&lang=js"
export * from "./rightSideber.vue?vue&type=script&lang=js"
import style0 from "./rightSideber.vue?vue&type=style&index=0&id=12c3099c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports